const state = {
    userName: '',//用户名
    roles:'', //角色code
    staffCode:'', //职员code
    leaderFirst:'', //用来判断角色类型的： 1主管 2普通角色 3特殊角色
    staffStatus:"", //职员在职状态
    tokens:'', // token值
};
export default state;


// WEBPACK FOOTER //
// ./src/store/state.js